import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CdnDomain } from '@vshosting/models';
import { DOMAIN_STATUS_COLOR_MAP } from '@vshosting/cdn/core';
import { SatPopoverAnchorDirective, SatPopoverComponent } from '@ncstate/sat-popover';

@Component({
  selector: 'vshcdn-domain-info',
  templateUrl: './domain-info.component.html',
  styleUrls: ['./domain-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCardModule,
    MatIconModule,
    SatPopoverAnchorDirective,
    SatPopoverComponent
  ]
})
export class DomainInfoComponent {

  domainStatusColorMap = DOMAIN_STATUS_COLOR_MAP;
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  #popoverTimeouts: { [key: string]: any } = {};
  #popoverStates: { [key: string]: boolean } = {};

  @Input()
  data: CdnDomain;

  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translations: any;

  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  generalTranslations: any;

  openPopover(popoverId: string, popoverRef: SatPopoverComponent): void {
    clearTimeout(this.#popoverTimeouts[popoverId]);
    this.#popoverStates[popoverId] = true;
    popoverRef.open();
  }

  closePopover(popoverId: string, popoverRef: SatPopoverComponent): void {
    this.#popoverTimeouts[popoverId] = setTimeout(() => {
      this.#popoverStates[popoverId] = false;
      popoverRef.close();
    }, 150);
  }

}
